import React, { useState } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import pt from 'date-fns/locale/pt'
import 'react-datepicker/dist/react-datepicker.css'
import { SearchIcon, Calendar as CalendarIcon } from '../../normalizer'

registerLocale('pt', pt)

const PT_MONTHS = [
  "Janeiro","Fevereiro","Março","Abril","Maio","Junho",
  "Julho","Agosto","Setembro","Outubro","Novembro","Dezembro",
]

const DatePickerHeader = ({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
  <div className="gl-datepicker__header">
    <button type="button" className="gl-datepicker__nav gl-datepicker__nav--prev" onClick={decreaseMonth} disabled={prevMonthButtonDisabled} aria-label="Mês anterior">‹</button>
    <span className="gl-datepicker__month-year">{PT_MONTHS[date.getMonth()]} {date.getFullYear()}</span>
    <button type="button" className="gl-datepicker__nav gl-datepicker__nav--next" onClick={increaseMonth} disabled={nextMonthButtonDisabled} aria-label="Próximo mês">›</button>
  </div>
)

const SalesFilter = ({ onSaleFilter }) => {
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [username, setUsername] = useState('')

  const handleStartDateChange = (date) => {
    setStartDate(date)
    onSaleFilter({ startDate: date, endDate, username })
  }

  const handleEndDateChange = (date) => {
    setEndDate(date)
    onSaleFilter({ startDate, endDate: date, username })
  }

  const handleUsernameChange = (e) => {
    const value = e.target.value
    setUsername(value)
    // Trim trailing/leading whitespace before sending to the API so a lone
    // space doesn't produce a non-matching search query.
    onSaleFilter({ startDate, endDate, username: value.trim() })
  }

  return (
    <div className="analytics-filters">
      <div className="gl-input">
        <div className="title">Jogador</div>
        <div className="input-container input-container--text">
          <span className="input-icon"><SearchIcon /></span>
          <input
            type="text"
            className="input"
            placeholder="Pesquisar jogador..."
            onChange={handleUsernameChange}
            value={username}
          />
        </div>
      </div>
      <div className="gl-input">
        <div className="title">Data início</div>
        <div className="input-container input-container--date">
          <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            maxDate={endDate}
            dateFormat="dd-MM-yyyy"
            locale="pt"
            placeholderText="dd/mm/aaaa"
            calendarClassName="gl-datepicker"
            className="input"
            renderCustomHeader={DatePickerHeader}
            showDisabledMonthNavigation
          />
          <span className="input-icon"><CalendarIcon /></span>
        </div>
      </div>
      <div className="gl-input">
        <div className="title">Data fim</div>
        <div className="input-container input-container--date">
          <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            minDate={startDate}
            dateFormat="dd-MM-yyyy"
            locale="pt"
            placeholderText="dd/mm/aaaa"
            calendarClassName="gl-datepicker"
            className="input"
            renderCustomHeader={DatePickerHeader}
            showDisabledMonthNavigation
          />
          <span className="input-icon"><CalendarIcon /></span>
        </div>
      </div>
    </div>
  )
}

export default SalesFilter
